{
  "enum": {
    "O5AwsDeployerV1CfChangesetLifecycle": {
      "AVAILABLE": "Available",
      "EXECUTION": "Execution",
      "TERMINAL": "Terminal",
      "UNAVAILABLE": "Unavailable",
      "UNSPECIFIED": "Unspecified"
    },
    "O5AwsDeployerV1CfLifecycle": {
      "COMPLETE": "Complete",
      "CREATE_FAILED": "Create Failed",
      "MISSING": "Missing",
      "PROGRESS": "Progress",
      "ROLLED_BACK": "Rolled Back",
      "ROLLING_BACK": "Rolling Back",
      "TERMINAL": "Terminal",
      "UNSPECIFIED": "Unspecified"
    },
    "O5AwsDeployerV1ClusterStatus": {
      "ACTIVE": "Active",
      "UNSPECIFIED": "Unspecified"
    },
    "O5AwsDeployerV1DeploymentStatus": {
      "AVAILABLE": "Available",
      "DONE": "Done",
      "FAILED": "Failed",
      "QUEUED": "Queued",
      "RUNNING": "Running",
      "TERMINATED": "Terminated",
      "TRIGGERED": "Triggered",
      "UNSPECIFIED": "Unspecified",
      "WAITING": "Waiting"
    },
    "O5AwsDeployerV1EnvironmentStatus": {
      "ACTIVE": "Active",
      "UNSPECIFIED": "Unspecified"
    },
    "O5AwsDeployerV1StackStatus": {
      "AVAILABLE": "Available",
      "MIGRATING": "Migrating",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "O5AwsDeployerV1ClusterQueryServiceClusterListFilterableFields": {
      "clusterId": "Cluster",
      "status": "Status"
    },
    "O5AwsDeployerV1DeploymentQueryServiceDeploymentListFilterableFields": {
      "clusterId": "Cluster",
      "data": {
        "spec": {
          "appName": "App Name",
          "cfStackName": "CF Stack Name",
          "ecsCluster": "ECS Cluster",
          "environmentId": "Environment",
          "environmentName": "Environment Name",
          "source": {
            "inline": {
              "application": {
                "databases": {
                  "engine": {
                    "!type": "Database Engine Type",
                    "postgres": {
                      "migrateContainer": {
                        "demand": "Migrate Container Demand",
                        "envVars": {
                          "spec": {
                            "!type": "Migrate Container Env Vars Type",
                            "blobstore": {
                              "format": {
                                "!type": "Format Type"
                              }
                            }
                          }
                        },
                        "source": {
                          "!type": "Source Type"
                        }
                      },
                      "runInbox": "Run Inbox",
                      "runOutbox": "Run Outbox"
                    }
                  }
                },
                "runtimes": {
                  "containers": {
                    "demand": "Runtimes Containers Demand",
                    "envVars": {
                      "spec": {
                        "!type": "Runtimes Containers Env Vars Type",
                        "blobstore": {
                          "format": {
                            "!type": "Format Type"
                          }
                        }
                      }
                    },
                    "source": {
                      "!type": "Runtimes Containers Source Type"
                    }
                  }
                }
              }
            }
          },
          "version": "Version"
        }
      },
      "deploymentId": "Deployment",
      "environmentId": "Environment",
      "stackId": "Stack",
      "status": "Status"
    },
    "O5AwsDeployerV1EnvironmentQueryServiceEnvironmentListFilterableFields": {
      "clusterId": "Cluster",
      "environmentId": "Environment",
      "status": "Status"
    },
    "O5AwsDeployerV1StackQueryServiceStackListFilterableFields": {
      "clusterId": "Cluster",
      "environmentId": "Environment",
      "stackId": "Stack",
      "status": "Status"
    }
  },
  "oneOf": {
    "O5AwsDeployerV1CloudFormationStackParameterSource": {
      "resolve": "Resolve",
      "value": "Value"
    },
    "O5AwsDeployerV1CloudFormationStackParameterType": {
      "rulePriority": "Rule Priority"
    },
    "O5AwsDeployerV1ClusterEventType": {
      "configured": "Configured",
      "override": "Override"
    },
    "O5AwsDeployerV1DeploymentEventType": {
      "created": "Created",
      "done": "Done",
      "error": "Error",
      "runStep": "Run Step",
      "runSteps": "Run Steps",
      "stackAvailable": "Stack Available",
      "stackCreate": "Stack Create",
      "stackWait": "Stack Wait",
      "stackWaitFailure": "Stack Wait Failure",
      "stepResult": "Step Result",
      "terminated": "Terminated",
      "triggered": "Triggered"
    },
    "O5AwsDeployerV1DeploymentStepType": {
      "awaitImages": "Await Images",
      "cfCreate": "CF Create",
      "cfPlan": "CF Plan",
      "cfScale": "CF Scale",
      "cfUpdate": "CF Update",
      "evalJoin": "Eval Join",
      "pgDestroy": "PG Destroy",
      "pgEvaluate": "PG Evaluate",
      "pgUpsert": "PG Upsert",
      "publishKubernetesManifests": "Publish Kubernetes Manifests"
    },
    "O5AwsDeployerV1EnvironmentEventType": {
      "configured": "Configured"
    },
    "O5AwsDeployerV1PostgresConnectionType": {
      "aurora": "Aurora"
    },
    "O5AwsDeployerV1RdsHostType": {
      "aurora": "Aurora"
    },
    "O5AwsDeployerV1Source": {
      "github": "GitHub",
      "inline": "Inline"
    },
    "O5AwsDeployerV1SourceGithubRef": {
      "branch": "Branch",
      "commit": "Commit",
      "tag": "Tag"
    },
    "O5AwsDeployerV1StackEventType": {
      "configured": "Configured",
      "deploymentCompleted": "Deployment Completed",
      "deploymentFailed": "Deployment Failed",
      "deploymentRequested": "Deployment Requested",
      "runDeployment": "Run Deployment"
    },
    "O5AwsDeployerV1StepOutputType": {
      "cfChangesetStatus": "CF Changeset Status",
      "cfStackStatus": "CF Stack Status",
      "publishKubernetesManifests": "Publish Kubernetes Manifests"
    },
    "O5AwsDeployerV1TemplateType": {
      "emptyStack": "Empty Stack",
      "s3Template": "S3 Template",
      "templateBody": "Template Body"
    },
    "O5AwsDeployerV1TriggerManageAction": {
      "archive": "Archive",
      "upsert": "Upsert"
    },
    "O5AwsDeployerV1TriggerManageActionUpsertPayload": {
      "static": "Static"
    },
    "O5AwsDeployerV1UpsertClusterRequestSrc": {
      "config": "Config",
      "configJson": "JSON",
      "configYaml": "YAML"
    },
    "O5AwsDeployerV1UpsertEnvironmentRequestSrc": {
      "config": "Config",
      "configJson": "JSON",
      "configYaml": "YAML"
    }
  },
  "searchEnum": {
    "O5AwsDeployerV1EnvironmentQueryServiceEnvironmentListSearchableFields": {
      "data": {
        "config": {
          "fullName": "Full Name"
        }
      }
    },
    "O5AwsDeployerV1StackQueryServiceStackListSearchableFields": {
      "data": {
        "applicationName": "Application Name",
        "environmentName": "Environment Name",
        "stackName": "Stack Name"
      }
    }
  },
  "sortEnum": {
    "O5AwsDeployerV1ClusterQueryServiceClusterListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "O5AwsDeployerV1DeploymentQueryServiceDeploymentListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "O5AwsDeployerV1EnvironmentQueryServiceEnvironmentListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "O5AwsDeployerV1StackQueryServiceStackListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}